import { cloneDeep, isObject } from 'lodash'
import { formatIsoDateCustom, validateDateTimeFormat } from '@/global/services/helpers/dates'

const QUERY_REQUEST_TYPES = ['TEMPORARY_TRAFFIC_REGULATION', 'TEMPORARY_TRAFFIC_REGULATION_EXCAVATION']
const QUERY_CATEGORY = ['request_new', 'request_overview']
const VIEW_DATE_FORMAT = 'DD.MM.YYYY.'
const FORM_DATE_FORMAT = 'YYYY-MM-DD'
const VIEW_TIME_FORMAT = 'HH:mm'
const BLOCKS_RECEIVED_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export default {

  data () {
    return {
      damageVisible: false,
      authorizedVisible: false,
      internalDataVisible: false,
      conclusionVisible: false,
      historyVisible: false,
      showApplicationModifyBtn: false,
      showInvestorModifyBtn: false,
      showContractorModifyBtn: false,
      showAuthorizedPersonModifyBtn: false,
      fieldsVisibilityConfig: {
        regulation_setter: {
          visible: false,
          row: null,
          column: null,
          colSpan: null
        },
        completed_excavation: {
          visible: false,
          row: null,
          column: null,
          colSpan: null
        },
        excavation_purpose: {
          visible: false
        }
      },
      dataFromRequestRefreshDisabled: false,
      dataFromRequestShowLoader: false
    }
  },

  computed: {
    dataFromRequest () {
      return {
        title: this.$t('road-maintenance/aggregator.data_from_request'),
        key: 'request-data',
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: () => {
              return this.$route.params.id ? `traffic-regulation/${this.$route.params.id}/from-request` : 'traffic-regulation'
            },
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/from-request`,
            method: 'get'
          }
        },
        editUpdate: (event) => this.dataEditUpdated(event),
        modifyDataBeforeSend: (event) => this.modifyData(event),
        dataFetched: (event) => this.onDataFetched(event),
        afterCancel: (event) => this.onDataFetched(event),
        afterSave: (event, data) => this.onDataFetched(event, data),
        hiddenFormKeys: [
          'sidewalk',
          'sidewalk_type',
          'sidewalk_desc',
          'roadway',
          'roadway_type',
          'roadway_desc',
          'road_shoulder',
          'road_shoulder',
          'road_shoulder_type',
          'road_shoulder_desc',
          'curb',
          'curb_type',
          'curb_desc',
          'gutter',
          'gutter_type',
          'gutter_desc',
          'roadway_markings',
          'roadway_markings_type',
          'roadway_markings_desc',
          'traffic_sign',
          'traffic_sign_type',
          'traffic_sign_desc',
          'road_equipment',
          'road_equipment_type',
          'road_equipment_desc',
          'speed_bumps',
          'speed_bumps_type',
          'speed_bumps_desc',
          'attachments',
          'deleted_attachments',
          'latitude',
          'longitude',
          'regulation_setter_id',
          'road_id',
          'consent_data'
        ],
        tabContent: [
          // Tab action buttons
          {
            key: 'tab-action-header',
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance/aggregator.data_from_request'),
            showEditButtons: true,
            showBackButton: {
              uiViewName: this.$route?.meta?.parent_vue_name ?? null
            },
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                showLoader: this.dataFromRequestShowLoader,
                disabled: this.dataFromRequestRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}

                  this.dataFromRequestShowLoader = true
                  this.dataFromRequestRefreshDisabled = true
                  if (typeof fetchTabData === 'function') {
                    await fetchTabData()
                  }

                  this.dataFromRequestShowLoader = false
                  setTimeout(() => {
                    this.dataFromRequestRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                click: (event) => this.onChangeStatus(event)
              }
            ],
            onCancelTabSave: (event) => this.onCancel(event)
          },
          // Internal data
          {
            key: 'internal-data',
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-internal-blocks-main',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.internal_data'),
            visible: this.internalDataVisible,
            columnsConfig: [
              {
                key: 'foreign_code',
                customValue: () => {
                  return this.$route?.params?.id || null
                },
                title: this.$t('road-maintenance/aggregator.request_id') + ':'
              },
              {
                key: 'created_at',
                title: this.$t('road-maintenance/aggregator.request_created_date') + ':',
                customValue: (data) => {
                  return data?.created_at ? formatIsoDateCustom(data.created_at, BLOCKS_RECEIVED_DATE_FORMAT, VIEW_DATE_FORMAT) : ''
                }
              },
              {
                key: 'doc_class',
                title: this.$t('road-maintenance/aggregator.class') + ':'
              },
              {
                key: 'registry_number',
                title: this.$t('road-maintenance/aggregator.registration_number') + ':'
              },
              {
                key: 'source',
                title: this.$t('road-maintenance/aggregator.source') + ':',
                customValue: (data) => {
                  return data?.source ? this.$t(data.source) : '-'
                }
              }
            ],
            dataKey: 'internal_data'
          },
          // Location information
          {
            key: 'location',
            component: this.locationInformationComponent
          },
          // Applicant
          {
            key: 'applicant',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.applicant_information'),
            titleClasses: 'modified-title',
            insideCardButtons: {
              position: 'right',
              buttons: [
                {
                  type: 'base',
                  label: this.$t('road-maintenance/aggregator.confirm_data'),
                  visible: this.showApplicationModifyBtn && this.$route.query.category !== 'request_new',
                  prependIcon: 'mdi-exclamation',
                  color: '#f50000',
                  style: {
                    color: '#FFFFFF'
                  },
                  prependIconStyle: {
                    color: '#FFFFFF !important',
                    fontSize: '19px'
                  },
                  click: (event) => this.onModifyData(event, 'applicant')
                }
              ]
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'applicant_first_name',
                    label: this.$t('road-maintenance/aggregator.first_name') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_last_name',
                    label: this.$t('road-maintenance/aggregator.last_name') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_oib',
                    label: 'OIB*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_address_street',
                    label: this.$t('road-maintenance/aggregator.address_street') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_address_number',
                    label: this.$t('road-maintenance/aggregator.house_number') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_phone_number',
                    label: this.$t('road-maintenance/aggregator.phone_number') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Request details
          {
            key: 'request-details',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.request_details'),
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'city_district',
                    label: this.$t('road-maintenance/aggregator.city_district') + '*',
                    options: {
                      custom_display_value: (value) => {
                        return value?.name ?? null
                      }
                    },
                    row: 1,
                    column: 1,
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'address_street',
                    label: this.$t('road-maintenance/aggregator.address_street') + '*',
                    options: {
                      custom_display_value: (value) => {
                        return value?.name ?? null
                      }
                    },
                    row: 1,
                    column: 2,
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'address_number',
                    label: this.$t('road-maintenance/aggregator.house_number') + '*',
                    row: 1,
                    column: 3,
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'work_type',
                    label: this.$t('road-maintenance/aggregator.type_of_works') + '*',
                    type: 'textarea',
                    row: 2,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'excavation_reason',
                    label: this.$t('road-maintenance/aggregator.excavation_purpose') + '*',
                    type: 'textarea',
                    row: 2,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: this.fieldsVisibilityConfig.excavation_purpose.visible
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.time_period'),
                    row: 3,
                    column: 1,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    key: 'date_from',
                    type: 'datetime-picker',
                    subType: 'date',
                    format: 'DD.MM.YYYY.',
                    label: this.$t('road-maintenance/aggregator.date_from') + '*',
                    appendIcon: 'mdi-calendar',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !validateDateTimeFormat(value, VIEW_DATE_FORMAT)) {
                        updateValidationErrors({
                          date_from: this.$t('base.invalid_date').replace(':format', VIEW_DATE_FORMAT)
                        })
                      }
                    },
                    row: 4,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'date_to',
                    type: 'datetime-picker',
                    subType: 'date',
                    format: 'DD.MM.YYYY.',
                    label: this.$t('road-maintenance/aggregator.date_to') + '*',
                    appendIcon: 'mdi-calendar',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !validateDateTimeFormat(value, VIEW_DATE_FORMAT)) {
                        updateValidationErrors({
                          date_to: this.$t('base.invalid_date').replace(':format', VIEW_DATE_FORMAT)
                        })
                      }
                    },
                    row: 4,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'time_from',
                    type: 'datetime-picker',
                    subType: 'time',
                    format: 'HH:mm',
                    label: this.$t('road-maintenance/aggregator.time_from'),
                    appendIcon: 'mdi-clock',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !validateDateTimeFormat(value, VIEW_TIME_FORMAT)) {
                        updateValidationErrors({
                          time_from: this.$t('base.invalid_time').replace(':format', VIEW_TIME_FORMAT)
                        })
                      }
                    },
                    row: 5,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'time_to',
                    type: 'datetime-picker',
                    subType: 'time',
                    format: 'HH:mm',
                    label: this.$t('road-maintenance/aggregator.time_to'),
                    appendIcon: 'mdi-clock',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !validateDateTimeFormat(value, VIEW_TIME_FORMAT)) {
                        updateValidationErrors({
                          time_to: this.$t('base.invalid_time').replace(':format', VIEW_TIME_FORMAT)
                        })
                      }
                    },
                    row: 5,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'complete_repair',
                    label: this.$t('road-maintenance/aggregator.complete_renovation') + '*',
                    type: 'autocomplete',
                    tooltip: {
                      component: this.rehabilitationTooltipComponent,
                      color: 'transparent'
                    },
                    items: [
                      {
                        id: 1,
                        name: 'Da'
                      },
                      {
                        id: 0,
                        name: 'Ne'
                      }
                    ],
                    fetchInitial: false,
                    row: this.fieldsVisibilityConfig.completed_excavation.row,
                    column: this.fieldsVisibilityConfig.completed_excavation.column,
                    colSpan: this.fieldsVisibilityConfig.completed_excavation.colSpan,
                    visible: this.fieldsVisibilityConfig.completed_excavation.visible,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'regulation_setter',
                    label: this.$t('road-maintenance/aggregator.prp_set') + '*',
                    items: this.dropdownValues?.regulation_setter ?? [],
                    type: 'autocomplete',
                    autocomplete_options: {
                      fetchInitial: false,
                      allowSearch: false,
                      custom_display_value: (item) => {
                        return item && item.description ? this.$t(item.description) : null
                      }
                    },
                    row: this.fieldsVisibilityConfig.regulation_setter.row,
                    column: this.fieldsVisibilityConfig.regulation_setter.column,
                    colSpan: this.fieldsVisibilityConfig.regulation_setter.colSpan,
                    visible: this.fieldsVisibilityConfig.regulation_setter.visible,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          },
          // Investor
          {
            key: 'investor',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.investor_of_the_costs'),
            titleClasses: 'modified-title',
            insideCardButtons: {
              position: 'right',
              buttons: [
                {
                  type: 'base',
                  label: this.$t('road-maintenance/aggregator.confirm_data'),
                  visible: this.showInvestorModifyBtn && this.$route.query.category !== 'request_new',
                  prependIcon: 'mdi-exclamation',
                  color: '#f50000',
                  style: {
                    color: '#FFFFFF'
                  },
                  prependIconStyle: {
                    color: '#FFFFFF !important',
                    fontSize: '19px'
                  },
                  click: (event) => this.onModifyData(event, 'investor')
                }
              ]
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'investor_name',
                    label: this.$t('road-maintenance/aggregator.name') + '*',
                    row: 1,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'investor_address',
                    label: this.$t('road-maintenance/aggregator.address') + '*',
                    row: 1,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'investor_oib',
                    label: 'OIB*',
                    row: 2,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'investor_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    row: 2,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'investor_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    row: 2,
                    column: 3,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Contractor
          {
            key: 'contractor',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.contractor'),
            titleClasses: 'modified-title',
            insideCardButtons: {
              position: 'right',
              buttons: [
                {
                  type: 'base',
                  label: this.$t('road-maintenance/aggregator.confirm_data'),
                  visible: this.showContractorModifyBtn && this.$route.query.category !== 'request_new',
                  prependIcon: 'mdi-exclamation',
                  color: '#f50000',
                  style: {
                    color: '#FFFFFF'
                  },
                  prependIconStyle: {
                    color: '#FFFFFF !important',
                    fontSize: '19px'
                  },
                  click: (event) => this.onModifyData(event, 'contractor')
                }
              ]
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'contractor_name',
                    label: this.$t('road-maintenance/aggregator.name') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible_person',
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Authorized person
          {
            key: 'authorized-person',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.authorized_person'),
            titleClasses: 'modified-title',
            visible: this.authorizedVisible,
            insideCardButtons: {
              position: 'right',
              buttons: [
                {
                  type: 'base',
                  label: this.$t('road-maintenance/aggregator.confirm_data'),
                  visible: this.showAuthorizedPersonModifyBtn && this.$route.query.category !== 'request_new',
                  prependIcon: 'mdi-exclamation',
                  color: '#f50000',
                  style: {
                    color: '#FFFFFF'
                  },
                  prependIconStyle: {
                    color: '#FFFFFF !important',
                    fontSize: '19px'
                  },
                  click: (event) => this.onModifyData(event, 'installation_owner')
                }
              ]
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'installation_owner_name',
                    label: this.$t('fleet/documents/prl_cargo.name_and_surname') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_owner_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_owner_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Anticipated damage
          {
            key: 'damage',
            title: {
              text: this.$t('road-maintenance/aggregator.anticipated_damage')
            },
            style: this.$vuetify.breakpoint.mobile ? { marginTop: '25px' } : {
              border: '1px solid #E5E7EB',
              borderRadius: '16px',
              padding: '24px'
            },
            visible: this.damageVisible,
            component: this.anticipatedDamageComponent,
            dropdownValues: this.dropdownValues
          },
          // Attachments
          {
            key: 'attachments',
            component: this.attachmentsComponent,
            accept: '.jpg,.png,.pdf,.tif',
            attachmentsKey: 'attachments',
            baseLabel: 'Tip priloga',
            dropdownValues: this.dropdownValues,
            onFilesInput: (event) => this.onFilesInput(event),
            onFileDelete: (event) => this.onFileDelete(event)
          },
          // Conclusion
          {
            key: 'conclusion',
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.conclusion_request'),
            columnsConfig: [],
            dataKey: '',
            visible: this.conclusionVisible
          },
          // History
          {
            key: 'history',
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-internal-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.document_history'),
            columnsConfig: [],
            dataKey: '',
            visible: this.historyVisible
          }
        ]
      }
    }
  },

  methods: {
    manageFieldsByRequestType () {
      if (this.$route.query.request_type === QUERY_REQUEST_TYPES[1]) {
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'row', 6)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'column', 2)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'row', 6)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'column', 1)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.excavation_purpose, 'visible', true)
      }
      else {
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'row', 6)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'column', 1)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.excavation_purpose, 'visible', false)
      }
    },

    onCancel (event) {
      const { cancelTabSave } = event || {}
      if (this.$route.query.category === 'request_new') {
        this.$router.push({
          name: this.$route.name,
          query: {
            category: QUERY_CATEGORY[0]
          }
        }).then()
      }
      else if (typeof cancelTabSave === 'function') {
        cancelTabSave()
      }
    },

    dataEditUpdated (event) {
      const { edit, createMode } = event || {}

      this.manageFieldsByRequestType()
      if (edit) {
        this.internalDataVisible = false
        this.conclusionVisible = false
        this.historyVisible = false
      }
      else {
        this.internalDataVisible = !createMode
        this.conclusionVisible = !createMode
        this.historyVisible = !createMode
      }
      // Form type 2
      if (this.$route.query.request_type === QUERY_REQUEST_TYPES[1]) {
        this.authorizedVisible = true
        this.damageVisible = true
      }
      else {
        this.authorizedVisible = false
        this.damageVisible = false
      }
    },

    modifyData (event) {
      try {
        const { copiedData } = event || {}

        if (copiedData && isObject(copiedData)) {
          // Modify attachments to send only type and file
          if (copiedData && copiedData.attachments && copiedData.attachments.length) {
            copiedData.attachments = copiedData.attachments
              .map((attachment) => {
                if (!attachment.new) {
                  return {
                    type_id: attachment?.type_id ?? null,
                    file_id: attachment?.file_id ?? null
                  }
                }
                else {
                  return {
                    type_id: attachment?.type_id ?? null,
                    file_id: null,
                    file: attachment.file || null
                  }
                }
              })
              .filter(Boolean)
          }

          if (!copiedData.deleted_attachments) {
            copiedData.deleted_attachments = []
          }

          // Modify other data
          copiedData.date_from = copiedData.date_from ? formatIsoDateCustom(copiedData.date_from, VIEW_DATE_FORMAT, FORM_DATE_FORMAT) : null
          copiedData.date_to = copiedData.date_to ? formatIsoDateCustom(copiedData.date_to, VIEW_DATE_FORMAT, FORM_DATE_FORMAT) : null
          copiedData.time_from = copiedData.time_from ? copiedData.time_from + ':00' : null
          copiedData.time_to = copiedData.time_to ? copiedData.time_to + ':00' : null
          copiedData.request_type = this.$route?.query?.request_type ?? null
          copiedData.road_id = copiedData?.address_street?.id ?? null
          copiedData.address_street = copiedData?.address_street?.name ?? null
          copiedData.city_district = copiedData?.city_district?.id ?? copiedData?.city_district ?? null
          copiedData.regulation_setter_id = copiedData?.regulation_setter?.id ?? copiedData?.regulation_setter ?? null
          copiedData.roadway_type = copiedData?.roadway_type?.id ?? copiedData?.roadway_type ?? null
          copiedData.sidewalk_type = copiedData?.sidewalk_type?.id ?? copiedData?.sidewalk_type ?? null
          copiedData.road_shoulder_type = copiedData?.road_shoulder_type?.id ?? copiedData?.road_shoulder_type ?? null
          copiedData.curb_type = copiedData?.curb_type?.id ?? copiedData?.curb_type ?? null
          copiedData.gutter_type = copiedData?.gutter_type?.name ?? copiedData?.gutter_type ?? null
          copiedData.roadway_markings_type = copiedData?.roadway_markings_type?.id ?? copiedData?.roadway_markings_type ?? null
          copiedData.traffic_sign_type = copiedData?.traffic_sign_type?.name ?? copiedData?.traffic_sign_type ?? null
          copiedData.road_equipment_type = copiedData?.road_equipment_type?.id ?? copiedData?.road_equipment_type ?? null
          copiedData.speed_bump_type = copiedData?.speed_bump_type?.id ?? copiedData?.speed_bump_type ?? null
          copiedData.speed_bump_type = copiedData?.speed_bump_type?.id ?? copiedData?.speed_bump_type ?? null

          delete copiedData.regulation_setter

          return {
            ...copiedData
          }
        }

        return {}
      }
      catch (exception) {
        console.error(exception)
        return {}
      }
    },

    onFilesInput (event) {
      try {
        const { filesEvent, updateData, formData } = event || {}
        const newAttachments = formData && formData.attachments && formData.attachments.length ? formData.attachments : []
        if (filesEvent && typeof updateData === 'function') {
          const uploadedFiles = filesEvent.target.files
          const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'image/tiff'] // Allowed MIME types
          const maxFileSize = 200 * 1024 * 1024 // 200MB in bytes
          const maxFileSizeInMb = 200

          if (!formData.attachments) {
            updateData({
              attachments: []
            })
          }

          Array.from(uploadedFiles).forEach(file => {
            if (!allowedTypes.includes(file.type)) {
              this.pushNotification(`${this.$t('road-maintenance/aggregator.allowed_file_types_message').replace(':types', allowedTypes.join(','))}!`)
              console.warn(`File type not allowed: ${file.name} (${file.type})`)
              return
            }

            if (file.size > maxFileSize) {
              this.pushNotification(`${this.$t('road-maintenance/aggregator.exceeding_file_size_message').replace(':file', file?.name || '-').replace(':size', maxFileSizeInMb + 'MB')}!`)
              console.warn(`File size exceeds ${maxFileSizeInMb + 'MB'}: ${file.name}`)
              return
            }

            newAttachments.push({
              type_id: 'type_' + file.name,
              new: true,
              file_name: file?.name ?? '-',
              file: file,
              image: {
                src: '/img/icons/pdf-icon.svg',
                style: {
                  maxWidth: '40px',
                  height: '40px'
                }
              }
            })
          })
          updateData({
            attachments: newAttachments
          })
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onFileDelete (event) {
      const { file, updateData, formData } = event || {}
      let deletedFiles = []

      if (formData && formData?.deleted_attachments?.length) {
        deletedFiles = formData.deleted_attachments
      }
      if (file?.file_id) {
        deletedFiles.push(file.file_id)
      }

      if (file?.file_id && typeof updateData === 'function') {
        updateData({
          deleted_attachments: deletedFiles
        })
      }
    },

    onDataFetched (event, afterSaveData = null) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}
      const { id } = afterSaveData ?? {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Update applicant
          applicant_first_name: data?.applicant?.first_name ?? null,
          applicant_last_name: data?.applicant?.last_name ?? null,
          applicant_oib: data?.applicant?.oib ?? null,
          applicant_address_number: data?.applicant?.address_number ?? null,
          applicant_address_street: data?.applicant?.address_street ?? null,
          applicant_phone_number: data?.applicant?.phone ?? null,
          applicant_email: data?.applicant?.email ?? null,

          // Update investor
          investor_name: data?.investor?.name ?? null,
          investor_address: data?.investor?.address ?? null,
          investor_oib: data?.investor?.oib ?? null,
          investor_phone_number: data?.investor?.phone ?? null,
          investor_email: data?.investor?.email ?? null,

          // Update contractor
          contractor_name: data?.contractor?.name ?? null,
          contractor_responsible_person: data?.contractor?.responsible_person ?? null,
          contractor_phone_number: data?.contractor?.phone ?? null,
          contractor_email: data?.contractor?.email ?? null,

          // Update location
          city_district: data?.road?.city_district ?? null,
          address_street: data?.road ?? null,
          address_number: data?.geolocation?.address_number ?? null,
          latitude: data?.geolocation?.latitude ?? null,
          longitude: data?.geolocation?.longitude ?? null,

          // Installation owner
          installation_owner_name: data?.installation_owner?.name ?? null,
          installation_owner_phone_number: data?.installation_owner?.phone ?? null,
          installation_owner_email: data?.installation_owner?.email ?? null
        })

        if (this.$route.query.category === QUERY_CATEGORY[1]) {
          updateData({
            road_id: data?.road?.id ?? null
          })
        }
      }

      // After save redirect user to the edit page
      if (this.$route.query.category === 'request_new' && id) {
        this.$router.push({
          name: this.$route.name,
          params: {
            id: id
          },
          query: {
            category: QUERY_CATEGORY[1],
            request_type: this.$route.query.request_type,
            open_tab: 'request-data'
          }
        }).then()
      }
      else {
        this.showApplicationModifyBtn = !data?.applicant?.id
        this.showInvestorModifyBtn = !data?.investor?.id
        this.showContractorModifyBtn = !data?.contractor?.id
        this.showAuthorizedPersonModifyBtn = !data?.installation_owner?.id
      }
    },

    onModifyData (event, type) {
      const { formData, updateData } = event || {}
      this.$set(this.completeDataDialogConfig, 'showDialog', true)
      this.$set(this.completeDataDialogConfig.config, 'currentData', cloneDeep(formData))
      this.$set(this.completeDataDialogConfig.config, 'type', type)
      this.$set(this.completeDataDialogConfig.config, 'updateData', (val) => updateData(val))
    }
  }
}
